import { apiClient } from '~/api/client';
import { CompanyJSONAPI } from '~/api/resources/company';

type ShowParams = {
  license: string;
  period?: string;
  trend_period?: string;
};

export type ShowResponse = {
  data: CompanyJSONAPI;
  meta?: {
    volume: number;
    transactions_count: number;
    refinance_amount: number;
    purchase_amount: number;
  };
  error?: string;
};

export const show = async ({ license, ...params }: ShowParams) =>
  apiClient.get<ShowResponse>(`/companies/${license}`, { params });
